// src/api/axiosInstance.ts
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_HOST, // API의 기본 URL
  timeout: 10000, // 요청 타임아웃 (ms)
});

// 요청 인터셉터: 토큰 추가
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ACCESS_TOKEN"); // 토큰 저장 위치
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      // FormData 요청에는 Content-Type을 자동 설정
      delete config.headers["Content-Type"];
    } else {
      // 기본적으로 JSON 요청에 Content-Type 설정
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터: 에러 처리
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
